export enum EipicProfileAction {
  ACTION_UPDATE_EIPIC_PROFILE = 'update',
}
